<template>
  <rich-button @click="commands.blockquote" v-bind:isActive="isActive.blockquote()" v-bind:icon="'quote-left'" />
</template>

<script>
  import BlockQuoteButton from './BlockQuoteButton.ts'
  export default BlockQuoteButton
</script>
